export default "__VITE_ASSET__Do2hDLdk__"